import { render, staticRenderFns } from "./ConfirmReceiveParcelDetail.vue?vue&type=template&id=4ec0182b&scoped=true"
import script from "./ConfirmReceiveParcelDetail.vue?vue&type=script&lang=js"
export * from "./ConfirmReceiveParcelDetail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmReceiveParcelDetail.vue?vue&type=style&index=0&id=4ec0182b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0182b",
  null
  
)

export default component.exports